import { z } from 'zod';

export const personnelSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  position: z.string()
    .optional()
    .refine((val) => !val || !/^\d+$/.test(val), {
      message: 'Position must not be a number',
    }),
  email: z.email('Invalid email address').or(z.literal('')),
  phone: z.string().optional(),
  organization: z.string().min(1, 'Organization is required'),
});

export type PersonnelFormSchema = z.infer<typeof personnelSchema>;
